import { MdMarkEmailRead } from 'react-icons/md';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Button, LazyImage } from '@gbs-monorepo-packages/common';
import { colors, radii } from '@gbs-monorepo-packages/styles';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const TextContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  padding: 0 0 0.5rem;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  margin: 1.5rem auto;
`;

export const Description = styled.p`
  font-size: 0.875rem;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

// export const Label = styled(LabelPrimitiveRoot)`
export const Label = styled.label`
  background-color: ${colors.white300};
  color: ${colors.labelText};
  font-size: 0.875rem;
  left: 16px;
  max-width: 90%;
  overflow: hidden;
  padding: 1px 6px;
  position: absolute;
  text-overflow: ellipsis;
  top: 50%;
  transform-origin: 0;
  transform: translateY(-50%);
  transition:
    transform 0.15s ease-in-out,
    top 0.15s ease-in-out,
    padding 0.15s ease-in-out;
  user-select: none;
  white-space: nowrap;
  z-index: 1;
`;

interface IFieldsetProps {
  readonly filled: boolean;
  readonly isInvalid?: boolean;
}

export const Fieldset = styled.fieldset<IFieldsetProps>`
  all: unset;
  align-items: center;
  background-color: ${colors.white300};
  border-radius: ${radii.lg};
  border: 1px solid ${colors.authPagesFieldBorder};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  position: relative;
  transition:
    box-shadow 0.2s ease-in-out,
    border-color 0.2s ease-in-out;

  &:focus-within {
    border: 1px solid ${colors.authPagesFieldBorder};

    & ${Label} {
      color: ${colors.fieldFocus};
      top: -2px;
      transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
      white-space: normal;
    }
  }

  ${({ filled = false, isInvalid = false }) =>
    filled &&
    (!isInvalid
      ? css`
          border: 1px solid ${colors.fieldFocus};

          & ${Label} {
            color: ${colors.fieldFocus};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `
      : css`
          border: 1px solid ${colors.red300};

          & ${Label} {
            color: ${colors.red300};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `)}
`;

export const Input = styled.input`
  -webkit-appearance: none;
  background-color: none;
  border-radius: ${radii.lg};
  border: none;
  color: ${colors.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 2.5rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;
  transition:
    box-shadow 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
`;

export const EmailContainer = styled.div`
  all: unset;
  align-items: center;
  border-radius: 50%;
  border: 3px solid ${colors.button};
  color: ${colors.button};
  display: inline-flex;
  font-size: 1rem;
  height: 3.5rem;
  justify-content: center;
  width: 3.5rem;
  margin-bottom: 1.5rem;
`;

export const EmailIcon = styled(MdMarkEmailRead)`
  height: 2rem;
  width: 2rem;
`;

export const ErrorMessage = styled.p`
  font-size: 0.875rem;
  color: ${colors.red300};
`;

export const ResendButton = styled.button`
  all: unset;
  cursor: pointer;
  align-items: center;
  border-radius: ${radii.sm};
  color: ${colors.white300};
  display: flex;
  font-size: 1rem;
  height: 3.25rem;
  justify-content: center;
  margin-top: 1.5rem;
  width: 100%;
  background-color: ${colors.button};

  &:hover {
    opacity: 0.9;
  }
`;

export const SubmitButton = styled(Button)`
  all: unset;
  align-items: center;
  background-color: ${colors.blue400};
  border-radius: ${radii.lg};
  color: ${colors.white300};
  display: flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  margin-top: 1.5rem;

  &:hover {
    opacity: 0.9;
  }
`;

export const LoginLinkContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 5rem;
`;

export const LoginLink = styled(Link)`
  align-items: center;
  color: ${colors.fieldFocus};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.5;
  padding: 0.25rem;
  text-decoration: none;
`;

export const LazyImageCustom = styled(LazyImage)`
  max-height: 6.875rem;
`;
